import {
    getAccountApplication,
    listAccountApplications
} from './queries';
import {
    createAccountApplication,
    deleteAccountApplication,
    updateAccountApplication,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    AccountApplication,
    CreateAccountApplication,
    DeleteAccountApplication,
    GetAccountApplication,
    ListAccountApplications,
    UpdateAccountApplication
} from "../types.ts";
import {
    notifyError,
    notifySuccess
} from "../../../../components/PlatformNotification";
import {generateClient} from "aws-amplify/api";

// import {
//     notifyError,
//     notifySuccess
// } from "@flexinet/ui-components";


const client = generateClient();

const normalizeFilter = (filter: { [key: string]: string }) => {
    return Object.keys(filter)
                 .reduce((acc: { [key: string]: string }, key: string) => {
                     if (filter[key] !== '') {
                         acc[key] = filter[key];
                     }
                     return acc;
                 }, {});

};

export const fetchRecords = async (filter?: { [key: string]: string }) => {

    // filter looks like this - {accountId: 'xxxxx', email: 'XXXXXXXXXXXXX'}

    let transformedFilter = {};
    if (typeof filter !== 'undefined') {
        transformedFilter = normalizeFilter(filter);
    }

    // after normalization filter looks like this - {accountId: 'xxxxx', email: 'XXXXXXXXXXXXX'}

    try {
        const response = await client.graphql<GraphQLQuery<ListAccountApplications>>({
                                                                                         query: listAccountApplications,
                                                                                         variables: {
                                                                                             filter: transformedFilter
                                                                                         },
                                                                                     });
        return response.data?.listAccountApplications;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetAccountApplication>>({
                                                                                       query: getAccountApplication,
                                                                                       variables: {id: id},
                                                                                   });
        return response.data?.getAccountApplication;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateAccountApplication>>({
                                                                                          query: createAccountApplication,
                                                                                          variables: {input: payload},
                                                                                      });
        notifySuccess();
        return response.data?.createAccountApplication;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const update = async (id: string, record: AccountApplication) => {


    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;


    try {
        const response = await client.graphql<GraphQLQuery<UpdateAccountApplication>>({
                                                                                          query: (updateAccountApplication),
                                                                                          variables: {input: record},
                                                                                      });

        notifySuccess('AccountApplication updated');
        return response.data?.updateAccountApplication;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteAccountApplication>>({
                                                                                          query: (deleteAccountApplication),
                                                                                          variables: {input: {id: id}},

                                                                                      });
        notifySuccess('AccountApplication deleted');
        return response.data?.deleteAccountApplication;
    } catch (e) {
        console.trace(e);
        notifyError(e)
        // FNP-795: RE-THROW. Swallowing here made the thunk resolve, so
        // deleteOneCase's `fulfilled` branch removed the row from the store even
        // though the server had refused — the UI claimed the seat was released while
        // it was still occupied, and only a refresh revealed otherwise.
        //
        // Latent before, load-bearing now: console-api REJECTS deleting an ACTIVE
        // AccountApplication (it is an occupied seat), so this path is reachable in
        // normal use rather than only on an outage. notifyError already showed the
        // user the real message; re-throwing is what keeps the store honest.
        throw e;
    }
};
